const LOAD_DEFAULT_WINS = (state) => {
  state.winsObj.res = '-1'      // control 0 is not found or invalid school code
}

const LOAD_DATA_WINS = (state, payload) => {
  state.winsObj = payload
  // console.log(state.school_dt)
}

const LOAD_DATA_WINS_PRO = (state, payload) => {
  state.province = payload
}

const LOAD_DATA_WINS_DIS = (state, payload) => {
  state.district = payload
}

const LOAD_DATA_WINS_COM = (state, payload) => {
  state.commune = payload
}

const LOAD_DATA_WINS_SCH = (state, payload) => {
  state.school = payload
}

const LOAD_DATA_WINS_SUM = (state, payload) => {
  state.summary = payload
}

export {
  LOAD_DEFAULT_WINS,
  LOAD_DATA_WINS,
  LOAD_DATA_WINS_PRO,
  LOAD_DATA_WINS_DIS,
  LOAD_DATA_WINS_COM,
  LOAD_DATA_WINS_SCH,
  LOAD_DATA_WINS_SUM
}
